import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkle, ArrowRight } from 'phosphor-react';
import { useAuth } from '../context/AuthContext';

/**
 * ConversionCTA
 * 
 * Simplified footer CTA for public profile pages.
 * 
 * Shows a single, clear call-to-action:
 * - Logged in: "Start Your Journal" (goes to dashboard)
 * - Not logged in: "Start Your Journal" (goes to signup)
 * 
 * Design: Premium, minimal, non-intrusive
 * Message: Focus on the value proposition
 */
export default function ConversionCTA() {
  const { user, isDemo } = useAuth();
  const isLoggedIn = user || isDemo;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-[#0A0A0A] via-[#121212] to-[#0A0A0A] border-t border-white/10 shadow-2xl shadow-black/50" data-testid="conversion-cta">
      <div className="max-w-[1600px] mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left: Simple value proposition */}
          <div className="hidden md:block">
            <p className="text-white/60 text-sm">
              Discover which setups are actually making you money.
            </p>
          </div>

          {/* Right: Single clear CTA */}
          <div className="flex items-center gap-4 mx-auto md:mx-0">
            <Link
              to={isLoggedIn ? "/dashboard" : "/signup"}
              className="flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-[#00E676] to-[#00C853] text-black font-bold text-sm rounded-sm hover:from-[#00E676] hover:to-[#00E676] transition-all shadow-lg shadow-[#00E676]/20"
              data-testid="cta-main-btn"
            >
              {isLoggedIn ? (
                <>
                  <ArrowRight size={18} weight="bold" />
                  Start Your Journal
                </>
              ) : (
                <>
                  <Sparkle size={18} weight="fill" />
                  Start Your Journal
                </>
              )}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
